<template>
    <div>
        <!-- TODO important!! add spinner -->
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'OidcCallback',
    methods: {
        ...mapActions({
            oidcSignInCallback: 'oidcStore/oidcSignInCallback',
        }),
    },
    mounted() {
        this.oidcSignInCallback()
            .then(() => {
                this.$router.push('/');
            })
            .catch((err) => {
                // eslint-disable-next-line
                console.error('Oidc Callback error:', err);
                this.$router.push('/');
            });
    },
};
</script>
